import {
  Vehicle,
  PaginationData,
} from 'constants/interface';
import {
  buildPaginationParams,
  getPaginationHeaders,
  PaginatedResponse,
  requestClient,
} from 'infra/request';

export interface CreateVehicleData extends Omit<
  Vehicle,
  'id' |
  'createdAt' |
  'updatedAt' |
  'createdBy' |
  'updatedBy'
> {}

export interface UpdateVehicleData {
  id: string
  data: CreateVehicleData
}

export interface VehicleApi {
  createVehicle(vehicleData: CreateVehicleData): Promise<Vehicle>
  updateVehicle(vehicleData: UpdateVehicleData): Promise<Vehicle>
  getVehicle(vehicleId: string): Promise<Vehicle>
  getVehicleList(filter: PaginationData): Promise<PaginatedResponse<Vehicle>>
}

const vehicleApiBuilder = (): VehicleApi => {
  const createVehicle = async (
    vehicleData: CreateVehicleData,
  ): Promise<Vehicle> => {
    const params: Record<string, unknown> = {
      ...vehicleData,
    };
    const result = await requestClient.post('/vehicles', params);

    const createdVehicle: Vehicle = result.data as Vehicle;
    return createdVehicle;
  };

  const updateVehicle = async (
    vehicleData: UpdateVehicleData,
  ): Promise<Vehicle> => {
    const { id: vehicleId, data } = vehicleData;
    const params: Record<string, unknown> = { ...data };
    const result = await requestClient.put(`/vehicles/${vehicleId}`, params);
    const updatedVehicle: Vehicle = result.data as Vehicle;
    return updatedVehicle;
  };

  const getVehicle = async (
    vehicleId: string,
  ): Promise<Vehicle> => {
    const result = await requestClient.get(`/vehicles/${vehicleId}`);
    const vehicle: Vehicle = result.data as Vehicle;
    return vehicle;
  };

  const getVehicleList = async (
    filterData: PaginationData,
  ): Promise<PaginatedResponse<Vehicle>> => {
    const params = buildPaginationParams(filterData);
    const result = await requestClient.get('/vehicles', params);
    const pagination = getPaginationHeaders(result);
    const vehicleList: Vehicle[] = result.data as Vehicle[];
    return {
      pagination,
      data: vehicleList,
    };
  };

  return {
    createVehicle,
    updateVehicle,
    getVehicle,
    getVehicleList,
  };
};

export const vehicleApi = vehicleApiBuilder();
